<template>
  <!-- 完善资料  获取抽奖资格 -->
  <div
    class="puzzle-form register-data text-center"
    :class="formState ? 'bind-data' : ''"
  >
    <div class="content">
      <div class="form-outer">
        <div class="inner">
          <div class="ftop">
            <div class="title bold">Congratulations!</div>
            <div class="description">Please confirm your contact information</div>
          </div>
          <div class="text" v-if="hasPrize" v-html="description"></div>
          <div class="form text-left">
            <div class="form-item">
              <input
                type="text"
                class="form-control"
                placeholder="Name"
                v-model="formData.nickname"
              />
            </div>
            <div class="form-item">
              <input
                type="text"
                class="form-control area-code fl"
                placeholder="Area Code"
                v-model="formData.areaCode"
              />
              <input
                type="text"
                class="form-control code-body"
                placeholder="Phone Number"
                v-model="formData.mobile"
              />
            </div>
            <div class="form-item">
              <input
                type="text"
                class="form-control"
                placeholder="Email"
                v-model="formData.email"
              />
            </div>
            <div class="form-item">
              <select
                class="form-control myselect"
                v-model="formData.country"
                :class="formData.country ? 'choosed' : ''"
              >
                <option value="">Country & Region</option>
                <option
                  :value="item.id"
                  v-for="(item, index) in regions"
                  :key="index"
                  >{{ item.name_en }}</option
                >
              </select>
            </div>
            <div class="submit-btn text-center" @click="handleSubmit">
              Submit
            </div>
          </div>
          <div class="iconfont close" @click="handleCloseForm">&#xe6e2;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountry, submitWinnerInfo } from "@/util/data.js";
import { showToast } from "@/util/utils.js";
export default {
  props: ["time", "showform", "submitTime", "rankIndex", "hasPrize"],
  data() {
    return {
      // formState:3,
      formData: {
        nickname: "",
        areaCode: "",
        mobile: "",
        email: "",
        country: "",
        countryName: ""
      },
      description:
        "Please be sure to fill in valid address and contact information,<br>otherwise it will be regarded as giving up the prize automatically.",
      regions: [],
      rankInfo: {}
    };
  },
  created() {
    this.getRegions();
    let userDetail = this.$store.state.userDetail;
    if (userDetail) {
      this.initFormData(userDetail);
    }
  },
  computed: {
    // formState() {
    //   return this.$store.state.showForm;
    // },
    formState: {
      get() {
        return this.$store.state.showForm;
      },
      set(v) {
        this.$store.state.showForm = v;
      }
    },
    token: function() {
      return this.$store.state.token || window.localStorage.getItem("token");
    }
  },
  watch: {
    formState(newVal) {
      if (!newVal && newVal !== 0) return;
      let userDetail = this.$store.state.userDetail;
      if (userDetail && newVal === 0) {
        this.initFormData(userDetail);
      }
    },
  },
  methods: {
    getRegions() {
      getCountry().then(res => {
        if (res.code == 200) {
          let formData = this.formData;
          this.regions = res.data;
          if (formData.country) {
            formData.countryName = this.getCountryName(formData.country);
          }
          this.formData = formData;
        }
      });
    },
    initFormData(userDetail) {
      let arr = userDetail.mobile ? userDetail.mobile.split("-") : [];
      let mobile = arr[1] ? arr[1] : arr[0];
      let areaCode = arr[1] ? arr[0] : "";
      let countryName = this.getCountryName(userDetail.country);
      let formData = {
        nickname: userDetail.nickname || "",
        areaCode: areaCode || "",
        mobile: mobile || "",
        email: userDetail.email || "",
        country: userDetail.country || "",
        countryName
      };
      this.formData = formData;
    },
    getCountryName(id) {
      let len = this.regions.length;
      for (let i = 0; i < len; i++) {
        let item = this.regions[i];
        if (item.id == id) {
          return item.name_en;
          break;
        }
      }
      return "";
    },
    handleSubmit() {
      // 验证邮箱的正则表达式
      const regEmail = /^[A-Za-z0-9]+([_.][A-Za-z0-9]+)*@([A-Za-z0-9-]+\.)+[A-Za-z]{2,6}$/;
      let nickname = this.formData.nickname,
        areaCode = this.formData.areaCode,
        mobile = this.formData.mobile,
        email = this.formData.email,
        country = this.formData.country;
      if (!nickname) {
        showToast(this, "Please fill in name!");
        return;
      }
      if (!areaCode) {
        showToast(this, "Please fill in area code!");
        return;
      }
      if (!mobile) {
        showToast(this, "Please fill in mobile!");
        return;
      }
      if (!email) {
        showToast(this, "Please fill in mail!");
        return;
      }
      if (!regEmail.test(email)) {
        showToast(this, "Please fill a correct email address!");
        return;
      }
      if (!country) {
        showToast(this, "Please fill in country!");
        return;
      }
      let tel = areaCode + "-" + mobile,
        token = this.$store.state.token || window.localStorage.getItem("token");
      let userDetail = this.$store.state.userDetail || {};
      userDetail.nickname = nickname;
      userDetail.mobile = tel;
      userDetail.email = email;
      userDetail.country = country;
      this.$store.commit("updateUserDetail", userDetail);
      this.$store.commit("updateRoleState", false);
      this.updateUserInfo({
        nickname,
        mobile: tel,
        email,
        country,
        activity_id:this.$route.params.id
      });
    },
    handleCloseForm() {
      this.formState = -1;
      this.$emit("close","");
      this.$store.commit("updateValue", ["showPrizeForm", false]);
    },
    updateUserInfo(data) {
      let token =
        this.$store.state.token || window.localStorage.getItem("token") || "no";
      submitWinnerInfo(data, token).then(res => {
        if (res.code == 1) {
          // showToast(this, "Success!");
          showToast(this, "The staff will contact you soon. Please pay attention to your email.", 2000);
          this.$store.commit("updateValue", ["showPrizeForm", false]);
        } else {
          showToast(this, res.msg);
        }
        this.handleCloseForm();
      });
    }
  }
};
</script>

<style scoped>
.puzzle-form {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 666;
  background: rgba(0, 0, 0, 0.6);
}
.puzzle-form .content {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  left: 50%;
  top: 50%;
  position: absolute;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 7px;
  box-sizing: content-box;
}
.puzzle-form .content .inner {
  padding: 45px 4.6% 35px 4.6%;
  position: relative;
}
.inner .ftop {
  color: rgba(255, 200, 77, 1);
  overflow: hidden;
  width: 320px;
  margin: 0 auto;
}
.ft-left {
  float: left;
  font-weight: 400;
  font-size: 18px;
}
.ft-left img {
  width: 57px;
}
.ft-right {
  float: left;
  text-align: left;
  margin-left: 20px;
}
.ftop .title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #0f173a;
}
.ftop .description{
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
  color: #333;
}
.ft-right .time {
  font-size: 15px;
  font-weight: 400;
  text-align: left;
  line-height: 20px;
  color: #0f173a;
}
.inner .text {
  text-align: center;
  color: #1d1d1d;
  margin-top: 18px;
  font-size: 14px;
  line-height: 18px;
}
.inner .form {
  margin-top: 20px;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #c3c3c3;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c3c3c3;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c3c3c3;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #c3c3c3;
}
.inner .form .form-control {
  height: 43px;
  border: 1px solid #939393;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 15px;
  padding-left: 10px;
  color: #1d1d1d;
}
.inner .form .form-control.myselect {
  color: #c3c3c3;
}
.inner .form .form-control.choosed {
  color: #1d1d1d;
}
.inner .form .form-control.area-code {
  width: 32.7%;
  float: left;
}
.inner .form .form-control.code-body {
  width: 62.6%;
  float: right;
}
.content .submit-btn {
  width: 215px;
  height: 45px;
  background: rgb(229, 173, 100);
  border-radius: 5px;
  text-align: center;
  line-height: 45px;
  color: white;
  font-size: 20px;
  letter-spacing: 1px;
  margin: 22px auto;
  margin-bottom: 0;
  cursor: pointer;
}
.content .close {
  color: #1d1d1d;
  padding: 10px;
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .puzzle-form .content {
    width: calc(100% - 30px);
  }
}

@media screen and (max-width: 375px) {
  .inner .ftop {
    width: 280px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LuckDraw/Form.vue